import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  message: null,
};

export const message = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMessage, clearMessage } = message.actions;

export default message.reducer;
